/**
 * Created by itripp on 2/17/2016.
 */
/// <reference path="../../app.definition.ts" />

import { Serializable } from "./Serializable";

export class InviteInfo implements Serializable<InviteInfo> {
    inviteId;
    inviterName: string;
    subjectName: string;
    adminInvite: boolean;
    isInvitationExpired: boolean;
    token: String;
    status: string;
    subjectId: number;
    deserialize(input: any) {
        !!input._id && (this.inviteId = input._id);
        !!input.inviterName && (this.inviterName = input.inviterName);
        !!input.subjectName && (this.subjectName = input.subjectName);
        !!input.adminInvite && (this.adminInvite = input.adminInvite);
        !!input.isInvitationExpired && (this.isInvitationExpired = input.isInvitationExpired);
        !!input.token && (this.token = input.token);
        !!input.status && (this.status = input.status);
        !!input.subjectId && (this.subjectId = input.subjectId);

        return this;
    }

    constructor() {
    }
}
